import * as yup from 'yup';

export const usePersonalDataStepFormSchema = () => {
  const schema = yup.object({
    title: yup.string().required('Title is a required field'),
    surname: yup.string().required('Surname is a required field'),
    forename: yup.string().required('Forename is a required field'),
    middleNames: yup.string(),
    changedName: yup.string(),
    previousSurname: yup.string(),
    previousForenames: yup.string(),
    gender: yup.string(),
    martialStatus: yup.string(),
    documentType: yup.string().required('Document Type is a required field'),
    documentNumber: yup.string().required('Document Number is a required field'),
    homeAddress: yup.string().required('Home Address is a required field'),
    postcode: yup.string().required('Postcode is a required field'),
    city: yup.string().required('City/Town is a required field'),
    state: yup.string().required('State/Province is a required field'),
    country: yup.string().required('Country is a required field'),
    typeOfResidence: yup.string(),
    homePhoneNumber: yup.string(),
    mobilePrefix: yup.string().required('Mobile Prefix is a required field'),
    mobilePhoneNumber: yup.string().required('Mobile Phone Number is a required field'),
    email: yup.string().required('Email is a required field'),
    height: yup.string(),
    placeOfBirth: yup.string(),
    dateOfBirth: yup.string().required('Date of Birth is a required field'),
    nationality: yup.string().required('Nationality is a required field'),
    previousAddresses: yup.string(),
    previousAddressesList: yup.array().when(['previousAddresses'], {
      is: (previousAddresses: string) => previousAddresses === '1',
      then: (schema) => schema.of(
        yup.object().shape({
          previousAddress: yup.string(),
          previousPostcode: yup.string(),
          prevCity: yup.string().required('City/Town is a required field'),
          prevState: yup.string().required('State/Province is a required field'),
          prevCountry: yup.string().required('Country is a required field'),
          prevFromDate: yup.string().required('From Date is a required field'),
          prevToDate: yup
            .string()
            .required('To Date is a required field')
            .min(yup.ref('prevFromDate'), 'The end date must be after the start date.'),
        }),
      ),
      otherwise: (schema) => schema.nullable(),
    }),

    occupation: yup.string(),
    workAddress: yup.string(),
    workPostcode: yup.string(),
    workCity: yup.string().when('isEmployment', {
      is: (isEmployment: string) => isEmployment === '1',
      then: (yupSchema) => yupSchema.required('City/Town is a required field'),
    }),
    workState: yup.string().when('isEmployment', {
      is: (isEmployment: string) => isEmployment === '1',
      then: (yupSchema) => yupSchema.required('State/Province is a required field'),
    }),
    workCountry: yup.string().when('isEmployment', {
      is: (isEmployment: string) => isEmployment === '1',
      then: (yupSchema) => yupSchema.required('Country is a required field'),
    }),
    workPhoneNumber: yup.string(),
    workEmail: yup.string(),
  });

  return { schema };
};

/*
diagnoseDetails: yup.string().when('beenDiagnosed', {
      is: (beenDiagnosed: any) => beenDiagnosed === '1',
      then: (yupSchema) => yupSchema.required('This field is required'),
    }),
 */
